module.exports = __webpack_public_path__ + "book.84608fee3e99e50f2fc8.png";


//////////////////
// WEBPACK FOOTER
// G:/UTL/Alumni/Alumni-ANG/src/assets/img/book.png
// module id = ../../../../../src/assets/img/book.png
// module chunks = styles